module.exports = require("./es-GQ.js");